<form DraggableDialog [formGroup]="form" (ngSubmit)="submit()">
  <div style="height:60px">
    <span *ngIf="newBus" mat-dialog-title class="title">Ny buss</span>
    <span *ngIf="!newBus" mat-dialog-title class="title">Redigera buss</span>
  </div>
  <mat-dialog-content>
    <div class="input-row-group right" style="flex:1; margin-top:12px;">
      <mat-checkbox data-cy-checkBox="performed" formControlName="active">Aktiv</mat-checkbox>
    </div>
    <div class="input-row-group" style="margin-top:12px;">
      <mat-form-field floatLabel="always" style="flex: 1; padding-right: 6px">
        <mat-label class="mat-input-header">Bussnummer</mat-label>
        <input type="text" matInput placeholder="Bussnummer" formControlName="number" data-cy-input="number">
      </mat-form-field>
      <mat-form-field floatLabel="always" style="flex:1;">
        <mat-label class="mat-input-header">Registreringsnummer</mat-label>
        <input type="text" matInput placeholder="Registreringsnummer" formControlName="registrationNumber" data-cy-input="registrationNumber">
      </mat-form-field>
    </div>

    <div class="input-row-group" style="margin-top:12px;">
      <mat-form-field floatLabel="always" style="flex:1;padding-right:6px">
        <mat-label class="mat-input-header">Kort/led</mat-label>
        <mat-select [formControl]="typesFormControl">
          <mat-option data-cy="options" *ngFor="let type of typeValues" [value]="type">{{type}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field floatLabel="always" style="flex:1;padding-right:6px">
        <mat-label class="mat-input-header">Gas/El</mat-label>
        <mat-select [formControl]="fuelTypesFormControl">
          <mat-option data-cy="options" *ngFor="let fuel of fuelTypeValues" [value]="fuel">{{fuel}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>


    <div style="border-bottom: 2px solid #0F1A41; width: 100%; margin-left:2px; margin-bottom: 20px; margin-top: 10px;"></div>
    <span mat-dialog-title class="sub-title">Service / tvätt</span>

    <div [formGroup]="serviceFormGroup">

      <div class="input-row-group">
        <mat-form-field floatLabel="always" style="flex:1; padding-right:6px; margin-top: 12px">
          <mat-label class="mat-input-header">Typ</mat-label>
          <mat-select [formControl]="serviceTypeFc">
            <mat-option data-cy="options" *ngFor="let service of allServiceTypes()" [value]="service">{{service}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field floatLabel="always" style="padding-right: 6px; flex: 1; margin-top: 12px ">
          <mat-label class="mat-input-header">Beskrivning</mat-label>
          <input type="text" matInput placeholder="" data-cy-input="serviceDescription" formControlName="description">
        </mat-form-field>
        <mat-form-field floatLabel="always" style=" margin-bottom: 10px">
          <div style="display:flex; height: 30px">
            <input matInput [matDatepicker]="picker" [formControl]="serviceDateFc">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </div>
        </mat-form-field>
      </div>

      <div class="input-row row">
        <div class="col" style="display: flex; justify-content: flex-start">
          <mat-checkbox class="" (click)="showAllClick()" formControlName="showAll">Visa utförda</mat-checkbox>
        </div>
        <div class="col" style="display: flex; justify-content: flex-end">
          <button type="button" *ngIf="serviceIsValid()" data-cy="download" class="add-button" (click)="addService()"><img src="../assets/images/green-add.svg" width="28" height="28" alt="Lägg till"/></button>
          <button type="button" *ngIf="!serviceIsValid()" data-cy="download" class="add-button" style="cursor: default"><img src="../assets/images/grey-add.svg" width="28" height="28" alt="Lägg till"/></button>
        </div>

      </div>
    </div>
    <div style="display: flex;flex-direction:row-reverse;margin-bottom:15px">
        <div class="mt-3" style="width: 100%;">
          <ag-grid-angular style="height: 20vh;"
                           class="ag-theme-material ag-theme-schedule"
                           [gridOptions]="gridOptions"
                           [rowData]="serviceData">
          </ag-grid-angular>
        </div>

      </div>
      <div style="border-bottom: 2px solid #0F1A41; width: 100%; margin-left:2px; margin-bottom: 20px; margin-top: 10px;"></div>

  </mat-dialog-content>
  <div style="display: flex;flex-direction:row-reverse;margin-right:15px;margin-bottom:15px">
    <button mat-flat-button type="submit" data-cy-btn="save"
            style="margin-left:10px;background:#7AB800" [disabled]="!canSave()">
      Spara
    </button>
    <button mat-button type="button" mat-dialog-close data-cy-btn="close"
            style="margin-left:10px;background:transparent;border-color:grey;color:grey;border-style:solid;border-width:1px">
      Stäng
    </button>
    <button mat-flat-button [disabled]="!canDelete()" (click)="deleteBus()" type="button" style="margin-left: 10px; background: #860022;" [ngStyle]="{'color': (canDelete()) ? '#FFFFFF' : 'grey'}">
      Radera
    </button>
  </div>
</form>

